module.exports = __webpack_public_path__ + "img/software_HL.f3da9c25.jpg";